import { render, staticRenderFns } from "./NavArrows.vue?vue&type=template&id=012cce71&scoped=true&"
import script from "./NavArrows.vue?vue&type=script&lang=js&"
export * from "./NavArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cce71",
  null
  
)

export default component.exports